export default defineAppConfig({
  ui: {
    colors: {
      primary: 'primary',
      info: 'info',
      success: 'success',
      secondary: 'secondary',
      warning: 'warning',
      neutral: 'neutral',
      error: 'error',
    },
    selectMenu: {
      variants: {
        variant: {
          subtle: 'bg-(--ui(--ui-primary-50))',
        },
      },
      defaultVariants: {
        variant: 'subtle',
      },
    },
    tabs: {
      defaultVariants: {
        variant: 'link',
      },
    },
    modal: {
      slots: {
        footer: 'justify-end',
      },
      variants: {
        fullscreen: {
          false: {
            content: 'w-full max-w-2xl',
          },
        },
      },
    },
    formField: {
      slots: {
        error: 'cy-error-class',
      },
    },
  },
});
